/**
 * HashNav
 * ======================================
 * - add active menu class for section in viewport
 */

const ITEMSCLASS = '.js-hashnav a'
const ACTIVECLASS = 'is-active'
const FIRSTACTIVE = true
const LASTACTIVE = false
const HEADER_HEIGHT = 110

class HashNav {
    constructor() {

        this.elements = document.querySelectorAll(ITEMSCLASS)
        this.first = this.elements[0]
        this.last = this.elements[this.elements.length - 1]
        this.offset = window.innerHeight / 2 - HEADER_HEIGHT

        document.addEventListener('scroll', this.scrollHandler, false)
        window.addEventListener('resize', this.scrollHandler, false)
        this.scrollHandler()
    }

    scrollHandler = () => {
        const top = window.pageYOffset || document.documentElement.scrollTop
        let foundActive = false

        this.elements.forEach(el => {
            const href = el.getAttribute('href')
            if (href.match('#') && href !== '#') {
                const target = document.querySelector(href)
                if (target) {
                    const targetRect = target.getBoundingClientRect()
                    const targetTop = targetRect.top + window.pageYOffset - HEADER_HEIGHT
                    const targetBottom = targetTop + targetRect.height

                    if (top + this.offset >= targetTop && top < targetBottom) {
                        this.resetClass()
                        el.classList.add(ACTIVECLASS)
                        foundActive = true
                    }
                }
            }
        })

        if (!foundActive) {
          this.resetClass()
          if (top + window.innerHeight >= document.documentElement.scrollHeight) {
              if (LASTACTIVE && this.last) {
                  this.last.classList.add(ACTIVECLASS)
              }
          } else if (top < HEADER_HEIGHT && this.first) {
              this.first.classList.add(ACTIVECLASS)
          }
        }
    }

    resetClass = () => {
        this.elements.forEach(el => {
            el.classList.remove(ACTIVECLASS)
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new HashNav()
})
